import { useState } from "react";

export function useVolunteerCreationFlow() {
  const [createdVolunteerId, setCreatedVolunteerId] = useState<number | null>(null);
  const [showAssignPrompt, setShowAssignPrompt] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);

  function onVolunteerCreated(volunteerId: number) {
    setCreatedVolunteerId(volunteerId);
    setShowAssignPrompt(true);
  }

  function onAssignConfirm() {
    setShowAssignPrompt(false);
    setShowAssignModal(true);
  }

  function onAssignSkip() {
    setShowAssignPrompt(false);
    setCreatedVolunteerId(null);
  }

  function onAssignComplete() {
    setShowAssignModal(false);
    setCreatedVolunteerId(null);
  }

  return {
    createdVolunteerId,
    showAssignPrompt,
    showAssignModal,
    onVolunteerCreated,
    onAssignConfirm,
    onAssignSkip,
    onAssignComplete,
  };
}
